import { MessageBox } from "element-ui";
let isUpdate = false;
async function checkUpdate() {
  const response = await fetch(`/version.json?v=${Date.now()}`);
  if (!response.ok) return;
  const res = await response.json();
  const latestVersion = res.version;
  const currentPageVersion = Number(
    document.querySelector('meta[name="version"]').content || "",
  );
  return latestVersion === currentPageVersion;
}

async function autoUpdate() {
  const bol = await checkUpdate();
  if (!bol) {
    if (isUpdate) return;
    isUpdate = true;
    location.reload();
  } else {
    isUpdate = false;
  }
}
if (process.env.NODE_ENV === "production") {
  autoUpdate();
  setInterval(() => {
    autoUpdate();
  }, 30000);
}
